// extracted by mini-css-extract-plugin
export default {"list":"N051L","listItem":"Ol17l"};